import axios from "axios";

class InheritanceService {
    /**
     * Обработчик обращения в bss для обновления цен
     * @param {number} hotelId - ID отеля
     * @param {boolean} onlyAdditionalData - Только дополнительные данные
     * @returns {Promise<Object>} - Результат запроса
     */
    static async handleInheritance(hotelId, onlyAdditionalData = false) {
        try {
            const response = await axios.delete("/api/inheritance_handler", {
                data: {
                    hotel_id: hotelId,
                    only_additional_data: onlyAdditionalData,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Inheritance handler error:", error);
            throw new Error("Ошибка обновления цен в BSS");
        }
    }
}

export default InheritanceService;
